<div class="card  my-2 tw-p-6 md:tw-p-8 tw-bg-yellowLight">

  <div class="tw-flex tw-items-center tw-gap-4">
    <img [width]="100" src="assets/images/landing-page/process1.svg" alt="">

    <div class="tw-flex-1 tw-flex tw-flex-col tw-items-center">
      <span class="tw-font-bold tw-text-3xl">Looking for a Company Car?</span>

      <div class="tw-flex tw-gap-4 tw-items-center tw-mt-4">
        <p class="tw-font-bold">Check out our</p>
        <a href="corporate-lease" aria-label="PumPumPum corporate lease">
          <button class="tw-bg-yellow tw-p-2 tw-rounded-md tw-text-white">Corporate Lease Plans</button>
        </a>
      </div>
    </div>
  </div>
</div>